/* global REACT_APP_ENV: true */

/**
 * App environment values as defined by string value passed to UMI_ENV variable when building the app. (See config files in config directory).
 */
export const AppEnvironments = {
  local: 0,
  dev: 1,
  uat: 2,
  production: 3,
};

export const AppEnvironmentNames = {
  [AppEnvironments.local]: "Local Development",
  [AppEnvironments.dev]: "Development",
  [AppEnvironments.uat]: "User Acceptance Testing",
  [AppEnvironments.production]: "Production",
};

const currentRunningEnv = AppEnvironments[REACT_APP_ENV];

export const isLocal = currentRunningEnv === AppEnvironments.local;
export const isDev = currentRunningEnv === AppEnvironments.dev;
export const isUAT = currentRunningEnv === AppEnvironments.uat;
export const isProd = currentRunningEnv === AppEnvironments.production;

export default currentRunningEnv;
